import { render, staticRenderFns } from "./Sftp.vue?vue&type=template&id=08e52934&"
import script from "./Sftp.vue?vue&type=script&lang=js&"
export * from "./Sftp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports